"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CATEGORY_DEFAULT = exports.CATEGORY = void 0;
var _userflow = _interopRequireDefault(require("../../styles/userflow"));
var CATEGORY_DEFAULT = exports.CATEGORY_DEFAULT = {
  styles: {
    container: {
      backgroundColor: 'transparent',
      color: _userflow["default"].colors.frenchGray
    }
  }
};
var CATEGORY = exports.CATEGORY = [{
  min: 0,
  max: 3,
  styles: {
    container: {
      backgroundColor: '#CAECD0'
    }
  }
}, {
  min: 3.1,
  max: 10,
  styles: {
    container: {
      backgroundColor: '#DCF0C8'
    }
  }
}, {
  min: 10.1,
  max: 15,
  styles: {
    container: {
      backgroundColor: '#F4F9DF'
    }
  }
}, {
  min: 15.1,
  max: Infinity,
  styles: {
    container: {
      backgroundColor: _userflow["default"].colors.white
    }
  }
}];